import React from 'react'
import { useBreakpointXs, Box } from '@plvs/respawn/features/layout'

export const HeroTabsGutter: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const mobile = useBreakpointXs()
  return <Box margin={mobile ? '0 16px 16px ' : '0 24px 24px'}>{children}</Box>
}
